import { combineReducers } from "redux";
import { authReducer, dashboardReducer, layoutReducer, settingsReducer, gridReducer } from "./reducers";
import { themeReducer } from "./reducers/themeReducer";

export const rootReducer = combineReducers({
  auth: authReducer,
  fw: layoutReducer,
  dashboard: dashboardReducer,
  settings: settingsReducer,
  tenantConfig: themeReducer,
  grid: gridReducer
});
